import { EditPredictionsSVG } from '@modules/feedback/components/EditPredictions/EditPredictionsSVG';
import {
  AccountTreeRounded,
  BookmarkRounded,
  EmailRounded,
  FilterListRounded,
  ManageAccountsRounded,
  PersonAddAltRounded,
  SettingsRounded,
  SpaceDashboardOutlined,
} from '@mui/icons-material';
import { SettingsIcon } from 'common/Icons/Icons';
import { PermissionResource } from 'generated/graphql';

export const INVITE_CODE_QUERY_PARAM = 'inviteCode';

export const PERMISSION_MODULE_LABEL_MAP: Partial<
  Record<PermissionResource, string>
> = {
  [PermissionResource.Integration]: 'Manage Integrations',
  [PermissionResource.Artefact]: 'Create/Edit Items',
  [PermissionResource.Invite]: 'Invite Users',
  [PermissionResource.Prediction]: 'Edit Predictions',
  [PermissionResource.Metadata]: 'Manage Metadata',
  [PermissionResource.Taxonomy]: 'Manage Taxonomy',
  [PermissionResource.Template]: 'Manage Dashboard Templates',
  [PermissionResource.OutboundIntegration]: 'Report Subscriptions',
  [PermissionResource.WorkspaceSettings]: 'Workspace Settings',
  [PermissionResource.AllCustomFilters]: 'All Custom Filters',
};

export const PERMISSION_MODULE_ICON_MAP: Partial<
  Record<PermissionResource, JSX.Element>
> = {
  [PermissionResource.Integration]: <SettingsIcon fill="currentColor" />,
  [PermissionResource.Artefact]: <BookmarkRounded />,
  [PermissionResource.Invite]: <PersonAddAltRounded />,
  [PermissionResource.Prediction]: (
    <EditPredictionsSVG fillColor="currentColor" />
  ),
  [PermissionResource.Metadata]: <SettingsRounded />,
  [PermissionResource.Taxonomy]: <AccountTreeRounded />,
  [PermissionResource.WorkspaceSettings]: <ManageAccountsRounded />,
  [PermissionResource.Template]: <SpaceDashboardOutlined />,
  [PermissionResource.OutboundIntegration]: <EmailRounded />,
  [PermissionResource.AllCustomFilters]: <FilterListRounded />,
};
